export { default as default } from './KitBadge';
